import { withDefaultColorScheme } from '@chakra-ui/react'

const colorScheme = withDefaultColorScheme({
  colorScheme: 'blue',
  components: ['Button', 'Text'],
})

export default colorScheme
